module.exports = __webpack_public_path__ + "img/grb_podvelka.png";